import React from "react";
import PropTypes from "prop-types";
import withTranslation from "../../../translation";
import Button from "../../../../components/Button";

import styles from "./index.css";

const DeliveryProposition = ({ defaultStoreUrl, formatTranslation }) => (
  <div className={styles.bagLinks}>
    <div className={styles.buttonContainer}>
      <Button
        theme="secondary"
        href={defaultStoreUrl.concat(formatTranslation("Bag.Link"))}
        data-test-id="bag-link"
      >
        {formatTranslation("MiniBag.Footer.BagLinks.Bag.Text")}
      </Button>
    </div>
    <div className={styles.buttonContainer}>
      <Button
        theme="green"
        href={defaultStoreUrl.concat(formatTranslation("Bag.Link"))}
        data-test-id="checkout-link"
      >
        {formatTranslation("MiniBag.Footer.BagLinks.Checkout.Text")}
      </Button>
    </div>
  </div>
);

DeliveryProposition.propTypes = {
  defaultStoreUrl: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(DeliveryProposition);



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/BagLinks/BagLinks.js